export interface LegalOperator {
  legalName: string;
  tradingName?: string;
  addressLines: readonly string[];
  country: string;
  email: string;
  phone?: string;
  register?: string;
  vatId?: string;
}

export const heiselLegalOperator: LegalOperator = Object.freeze({
  legalName: "Oliver Heisel",
  tradingName: "Heisel Analytics",
  addressLines: ["Händelstr. 3", "78464 Konstanz"],
  country: "Deutschland",
  email: "sailplot@heiselanalytics.one",
  phone: "+49 7531 122 82 05",
  vatId: "DE369969231",
});
